module.exports = __webpack_public_path__ + "media/images/logo-2-8e5ae8a56b54626951904e81edb9b987.svg";